import moment from 'moment'
import 'moment/locale/bs'
import 'moment/locale/de'
import 'moment/locale/en-in'
import 'moment/locale/sr'
import Vue from 'vue'

moment.locale('sr')

Vue.prototype.$moment = moment
